


import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";

const Lmsfeatures = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isTablet = useMediaQuery({ minWidth: 769, maxWidth: 1024 });
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // Animation trigger when component enters viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const styles = {
    outerContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: isMobile ? "1rem" : "2rem",
      backgroundColor: "#f5f7fa",
    },
    container: {
      maxWidth: "1200px",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#025261",
      color: "#fff",
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(40px)",
      transition: "all 0.8s ease-in-out",
    },
    leftSide: {
      flex: 1,
      padding: isMobile ? "1.5rem" : "2.5rem",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: isMobile ? 2 : 1,
    },
    rightSide: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: isMobile ? "1.5rem 1.5rem 0" : "2rem",
      order: isMobile ? 1 : 2,
    },
    header: {
      fontSize: isMobile ? "1.5rem" : isTablet ? "1.75rem" : "2rem",
      fontWeight: "700",
      color: "white",
      letterSpacing: "0px",
      marginBottom: "1rem",
      lineHeight: "1.2",
    },
    paragraph: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      margin: "0 0 1.5rem 0",
      lineHeight: "1.6",
      textAlign:"justify",
    },
    list: {
      listStyleType: "none",
      paddingLeft: 0,
      margin: 0,
    },
    listItem: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      marginBottom: "0.8rem",
      display: "flex",
      alignItems: "flex-start",
      lineHeight: "1.4",
    },
    arrow: {
      marginRight: "0.7rem",
      color: "#4CAF50",
      fontSize: isMobile ? "1rem" : "1.1rem",
      minWidth: "1.1rem",
      marginTop: "0.1rem",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
    image: {
      width: "100%",
      maxWidth: "500px",
      height: "auto",
      borderRadius: "8px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.2)",
    },
  };

  return (
    <div style={styles.outerContainer}>
      <div ref={sectionRef} style={styles.container}>
        {/* Right Side (Image) */}
        <div style={styles.rightSide}>
          <div style={styles.imageContainer}>
            <img
              src="/image/whylms.png"
              alt="Learning Management System Features"
              style={styles.image}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/500x350/025261/ffffff?text=LMS+Platform";
              }}
            />
          </div>
        </div>

        {/* Left Side (Text) */}
        <div style={styles.leftSide}>
          <h2 style={styles.header}>Learning Management System</h2>
          <p style={styles.paragraph}>
            Our learning management platform enables integration of any online
            eLearning or instructor-led training course schedules. The training
            management system catalog is customized based on your company's
            approved providers and catalog selections visible to learners driven
            by your training matrix.
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <span style={styles.arrow}>➔</span> 
              Courses automatically assigned based on job or role requirements
            </li>
            <li style={styles.listItem}>
              <span style={styles.arrow}>➔</span> 
              Learning plans, prerequisites, and equivalencies
            </li>
            <li style={styles.listItem}>
              <span style={styles.arrow}>➔</span> 
              Deploy and Report on Instructor and Virtual-Led Training
            </li>
            <li style={styles.listItem}>
              <span style={styles.arrow}>➔</span> 
              Training Vendor integration for scheduling and certificate generation
            </li>
            <li style={styles.listItem}>
              <span style={styles.arrow}>➔</span> 
              Automatic course certificate generation upon completion
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Lmsfeatures;